import { render, staticRenderFns } from "./Reorder.vue?vue&type=template&id=38bfff0a&scoped=true&"
import script from "./Reorder.vue?vue&type=script&lang=js&"
export * from "./Reorder.vue?vue&type=script&lang=js&"
import style0 from "./Reorder.vue?vue&type=style&index=0&id=38bfff0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bfff0a",
  null
  
)

export default component.exports